import { DynamicCalltrackingButton, EPageTypes, EPlatformTypes } from '@cian/frontend-dynamic-calltracking-component';
import * as React from 'react';

import * as styles from './CallButton.css';

interface ICallButtonProps {
  announcementId: number;
  handleShowPhoneClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent> | MouseEvent): void;
  isPhonesVisible: boolean;
  phone: string;
  siteBlockId: number | null;
}

export const CallButton = ({
  announcementId,
  handleShowPhoneClick,
  isPhonesVisible,
  phone,
  siteBlockId,
}: ICallButtonProps) => {
  return (
    <DynamicCalltrackingButton
      onClick={handleShowPhoneClick}
      className={styles['show-phone']}
      openPhoneClassName={styles['phones']}
      isOpen={isPhonesVisible}
      phone={phone}
      announcementId={announcementId}
      blockId={siteBlockId}
      placeType={'newbuildingPromosBanner'}
      platformType={EPlatformTypes.WebDesktop}
      pageType={EPageTypes.OfferCard}
    >
      Показать контакты
    </DynamicCalltrackingButton>
  );
};
